











































































import { ESearch, NavigationToggle, Pagination, Scrollbar, SvgImage } from '@/app/components';
import { computed, defineComponent, ref } from '@vue/composition-api';

import SortToggle from '@/app/components/SortToggle.vue';
import { SortToggleOption } from '@/app/types';
import { Icon } from '@iconify/vue2';
import { BreedingRhombusSpinner } from 'epic-spinners';
import { FakeRetrievalQueryCard, RetrievalQueryCard } from '../components';
import { useRetrievalQueries } from '../composable';
import { RetrievalStatus } from '../constants';
import { RetrievalQuery } from '../interfaces';

export default defineComponent({
    name: 'RetrievalQueries',
    metaInfo: { title: 'Retrieval' },
    components: {
        BreedingRhombusSpinner,
        Pagination,
        RetrievalQueryCard,
        FakeRetrievalQueryCard,
        SvgImage,
        Scrollbar,
        ESearch,
        NavigationToggle,
        SortToggle,
        Icon,
    },
    setup(props, { root }) {
        const uploadRequestedQueries = ref<string[]>([]);
        const pageSize = 10;
        const searchableFields = [
            {
                label: 'title',
                key: 'title',
                textColorClasses: 'text-primary-700',
                backgroundClasses: 'bg-primary-700',
                highlightClasses: 'bg-primary-300',
                widthClasses: 'pl-16 ml-2',
            },
            {
                label: 'description',
                key: 'description',
                textColorClasses: 'text-teal-700',
                backgroundClasses: 'bg-teal-700',
                highlightClasses: 'bg-teal-300',
                widthClasses: 'pl-28 ml-2',
            },
        ];

        const retrievalQueryStatuses = computed(() => {
            return [
                { label: 'All', key: 'all' },
                ...Object.keys(RetrievalStatus).map((statusLabel: string) => {
                    return {
                        label: statusLabel,
                        key: RetrievalStatus[statusLabel],
                    };
                }),
            ];
        });

        const {
            page,
            query,
            retrievalQueries,
            loading,
            totalResults,
            tab,
            sortBy,
            deleteRetrievalQuery,
            updateCurrentPage,
            sortByChanged,
            setTab,
            sortingFields,
            errors,
            querySortBy,
            sortByKeyAndDirection,
            getUploadRequestedQueries,
        } = useRetrievalQueries(root, 'retrieval', pageSize);

        const deleteQuery = (retrievalQuery: RetrievalQuery) => {
            deleteRetrievalQuery(retrievalQuery)
                .then(() => {
                    (root as any).$toastr.s(`Retrieval Query successfully deleted`, 'Successful deletion!');
                })
                .catch((error) => {
                    (root as any).$toastr.e(error, 'Validation error');
                });
        };

        const sortToggle = computed({
            get: (): { key: string; direction: string } => {
                return {
                    key: querySortBy.value.field,
                    direction: querySortBy.value.asc ? 'asc' : 'desc',
                };
            },
            set: (updatedSort: { key: string; direction: string }) => {
                sortByKeyAndDirection(updatedSort);
            },
        });
        const sortToggleOptions: SortToggleOption[] = [
            {
                key: 'date_updated',
                directions: [
                    { label: 'Last updated', direction: 'desc' },
                    { label: 'Oldest updated', direction: 'asc' },
                ],
            },
            {
                key: 'title',
                directions: [
                    { label: 'Title A-Z', direction: 'asc' },
                    { label: 'Title Z-A', direction: 'desc' },
                ],
            },
        ];

        getUploadRequestedQueries().then((rq) => {
            uploadRequestedQueries.value = rq;
        });

        return {
            tab,
            page,
            pageSize,
            loading,
            retrievalQueries,
            totalResults,
            sortingFields,
            retrievalQueryStatuses,
            query,
            sortBy,
            deleteQuery,
            updateCurrentPage,
            setTab,
            sortByChanged,
            searchableFields,
            errors,
            sortToggle,
            sortToggleOptions,
            querySortBy,
            uploadRequestedQueries,
        };
    },
});
